/**
 * @generated SignedSource<<9e956d4cc23300d000004a2f3162ed6b>>
 * @relayHash 03c3dbfa1bbf7f9299a90bfdb80219b7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7030f0a81a2e5c9d46334478bf967c3a7a14038bd09dec75a66456756e2b6473

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateCheckboxesFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraCheckboxesFieldOperationInput>;
};
export type JiraCheckboxesFieldOperationInput = {
  ids: ReadonlyArray<string>;
  operation: JiraMultiValueFieldOperations;
};
export type ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$variables = {
  input: JiraUpdateCheckboxesFieldInput;
};
export type ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$data = {
  readonly jira: {
    readonly updateCheckboxesField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly isDisabled: boolean | null | undefined;
              readonly optionId: string;
              readonly value: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly selectedOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly optionId: string;
              readonly value: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateCheckboxesField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly isDisabled: boolean | null | undefined;
              readonly optionId: string;
              readonly value: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly selectedOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly optionId: string;
              readonly value: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation = {
  rawResponse: ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$rawResponse;
  response: ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$data;
  variables: ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v6 = {
  "kind": "ScalarField",
  "name": "value"
},
v7 = {
  "kind": "ScalarField",
  "name": "isDisabled"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCheckboxesFieldPayload",
            "kind": "LinkedField",
            "name": "updateCheckboxesField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCheckboxesField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "selectedOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v4/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.selectedOptions.edges.node.id"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v5/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.selectedOptions.edges.node.optionId"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.selectedOptions.edges.node.value"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v4/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.fieldOptions.edges.node.id"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v5/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.fieldOptions.edges.node.optionId"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "NONE",
                                "path": "jira.updateCheckboxesField.field.fieldOptions.edges.node.value"
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCheckboxesFieldPayload",
            "kind": "LinkedField",
            "name": "updateCheckboxesField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraCheckboxesField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "selectedOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraOptionConnection",
                    "kind": "LinkedField",
                    "name": "fieldOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7030f0a81a2e5c9d46334478bf967c3a7a14038bd09dec75a66456756e2b6473",
    "metadata": {},
    "name": "ui_issueViewLayoutCheckboxSelectField_IssueViewCheckboxSelectField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "28c3be1f6895f0a2bfedfd47b258a023";

export default node;
